export enum EstadoAerovale {
    Precargado = 0,
    DespachoIniciado = 1,
    DespachoFinalizado = 2,
    Pendiente = 3,
    Finalizado = 4,
    FinalizadoSinFirma = 5,
    Sincronizado = 6,
    Anulado = 7
}